module.exports = __webpack_public_path__ + "./img/total-logo.a09564dfdd34e4a64930402470ff59b3.png";